// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Redirect route for the catalog area root.
 * Items is the default child section of the catalog.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/catalog/')({
  beforeLoad: () => {
    throw redirect({
      to: '/catalog/items',
    });
  },
});
